import { createActionGroup, props, emptyProps } from "@ngrx/store";
import { SubscriptionRequest } from "../@api/client-api";

export const SubscribePageActions = createActionGroup({
  source: "Subscribe Page",
  events: {
    "Subscribe Initiated": props<{
      subscriptionRequest: SubscriptionRequest;
    }>(),
    "Subscribe Succeeded": props<{
      subscriptionRequest: SubscriptionRequest;
    }>(),
    "Subscribe Failed": emptyProps(),
    "Subscribe Failed Wrong Email": emptyProps(),
  },
});

export const UiStateActions = createActionGroup({
  source: "UI State",
  events: {
    "Set Loading": props<{ isLoading: boolean }>(),
    'Set Server Error': props<{ serverError: string, serverErrorEmail: string }>(),
  },
});